// packages/eden-table/src/components/Table/TableSectionContext.jsx
import { createContext } from "react";
var TableSectionContext = createContext();
var TableSectionContext_default = TableSectionContext;
export {
  TableSectionContext_default as default
};
